var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("v-tour", {
        attrs: {
          name: "spider-list",
          steps: _vm.tourSteps,
          callbacks: _vm.tourCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c("v-tour", {
        attrs: {
          name: "spider-list-add",
          steps: _vm.tourAddSteps,
          callbacks: _vm.tourAddCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Add Spider"),
            width: "40%",
            visible: _vm.addDialogVisible,
            "before-close": _vm.onAddDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            { attrs: { "active-name": _vm.activeTabName } },
            [
              _c(
                "el-tab-pane",
                { attrs: { name: "customized", label: _vm.$t("Customized") } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "addCustomizedForm",
                      attrs: {
                        model: _vm.spiderForm,
                        "inline-message": "",
                        "label-width": "120px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Spider Name"),
                            prop: "name",
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "spider-name",
                              placeholder: _vm.$t("Spider Name")
                            },
                            model: {
                              value: _vm.spiderForm.name,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm, "name", $$v)
                              },
                              expression: "spiderForm.name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Display Name"),
                            prop: "display_name",
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "display-name",
                              placeholder: _vm.$t("Display Name")
                            },
                            model: {
                              value: _vm.spiderForm.display_name,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm, "display_name", $$v)
                              },
                              expression: "spiderForm.display_name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Project"),
                            prop: "project_id",
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("Project"),
                                filterable: ""
                              },
                              model: {
                                value: _vm.spiderForm.project_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.spiderForm, "project_id", $$v)
                                },
                                expression: "spiderForm.project_id"
                              }
                            },
                            _vm._l(_vm.projectList, function(p) {
                              return _c("el-option", {
                                key: p._id,
                                attrs: { value: p._id, label: p.name }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Execute Command"),
                            prop: "cmd",
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "cmd",
                              placeholder: _vm.$t("Execute Command"),
                              disabled: _vm.spiderForm.is_scrapy
                            },
                            model: {
                              value: _vm.spiderForm.cmd,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm, "cmd", $$v)
                              },
                              expression: "spiderForm.cmd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Results"), prop: "col" } },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "col",
                              placeholder:
                                _vm.$t("By default: ") + "results_<spider_name>"
                            },
                            model: {
                              value: _vm.spiderForm.col,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm, "col", $$v)
                              },
                              expression: "spiderForm.col"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Upload Zip File"),
                            "label-width": "120px",
                            name: "site"
                          }
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              attrs: {
                                action: _vm.$request.baseUrl + "/spiders",
                                data: _vm.uploadForm,
                                headers: { Authorization: _vm.token },
                                "on-success": _vm.onUploadSuccess,
                                "file-list": _vm.fileList,
                                "before-upload": _vm.beforeUpload
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    id: "upload",
                                    size: "small",
                                    type: "primary",
                                    icon: "el-icon-upload"
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Upload")) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Is Scrapy"),
                                    prop: "is_scrapy"
                                  }
                                },
                                [
                                  _c("el-switch", {
                                    attrs: { "active-color": "#13ce66" },
                                    on: { change: _vm.onIsScrapy },
                                    model: {
                                      value: _vm.spiderForm.is_scrapy,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.spiderForm,
                                          "is_scrapy",
                                          $$v
                                        )
                                      },
                                      expression: "spiderForm.is_scrapy"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Is Git"),
                                    prop: "is_git"
                                  }
                                },
                                [
                                  _c("el-switch", {
                                    attrs: { "active-color": "#13ce66" },
                                    model: {
                                      value: _vm.spiderForm.is_git,
                                      callback: function($$v) {
                                        _vm.$set(_vm.spiderForm, "is_git", $$v)
                                      },
                                      expression: "spiderForm.is_git"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Is Long Task"),
                                    prop: "is_long_task"
                                  }
                                },
                                [
                                  _c("el-switch", {
                                    attrs: { "active-color": "#13ce66" },
                                    model: {
                                      value: _vm.spiderForm.is_long_task,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.spiderForm,
                                          "is_long_task",
                                          $$v
                                        )
                                      },
                                      expression: "spiderForm.is_long_task"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-alert",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { type: "warning", closable: false }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              'You can click "Add" to create an empty spider and upload files later.'
                            )
                          )
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              'OR, you can also click "Upload" and upload a zip file containing your spider project.'
                            )
                          )
                        )
                      ]),
                      _c("p", [
                        _c("i", { staticClass: "fa fa-exclamation-triangle" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "NOTE: When uploading a zip file, please zip your" +
                                  " spider files from the ROOT DIRECTORY."
                              )
                            ) +
                            " "
                        )
                      ]),
                      _c(
                        "p",
                        { staticStyle: { "font-weight": "bolder" } },
                        [
                          _vm.lang === "en"
                            ? [
                                _vm._v(" Recommend uploading spiders using "),
                                _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      color: "#409eff",
                                      "font-weight": "bolder"
                                    },
                                    attrs: {
                                      href:
                                        "https://docs.iMango.cn/SDK/CLI.html",
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("CLI Tool")]
                                ),
                                _vm._v(". ")
                              ]
                            : _vm.lang === "zh"
                            ? [
                                _vm._v(" 推荐使用 "),
                                _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      color: "#409eff",
                                      "font-weight": "bolder"
                                    },
                                    attrs: {
                                      href:
                                        "https://docs.iMango.cn/SDK/CLI.html",
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("CLI 工具")]
                                ),
                                _vm._v(" 上传爬虫。 ")
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.onAddCustomized }
                        },
                        [_vm._v(_vm._s(_vm.$t("Add")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: { name: "configurable", label: _vm.$t("Configurable") }
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "addConfigurableForm",
                      attrs: {
                        model: _vm.spiderForm,
                        "inline-message": "",
                        "label-width": "120px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Spider Name"),
                            prop: "name",
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("Spider Name") },
                            model: {
                              value: _vm.spiderForm.name,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm, "name", $$v)
                              },
                              expression: "spiderForm.name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Display Name"),
                            prop: "display_name",
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("Display Name") },
                            model: {
                              value: _vm.spiderForm.display_name,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm, "display_name", $$v)
                              },
                              expression: "spiderForm.display_name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Project"),
                            prop: "project_id",
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("Project"),
                                filterable: ""
                              },
                              model: {
                                value: _vm.spiderForm.project_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.spiderForm, "project_id", $$v)
                                },
                                expression: "spiderForm.project_id"
                              }
                            },
                            _vm._l(_vm.projectList, function(p) {
                              return _c("el-option", {
                                key: p._id,
                                attrs: { value: p._id, label: p.name }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Template"),
                            prop: "template",
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                id: "template",
                                value: _vm.spiderForm.template,
                                placeholder: _vm.$t("Template")
                              },
                              model: {
                                value: _vm.spiderForm.template,
                                callback: function($$v) {
                                  _vm.$set(_vm.spiderForm, "template", $$v)
                                },
                                expression: "spiderForm.template"
                              }
                            },
                            _vm._l(_vm.templateList, function(template) {
                              return _c("el-option", {
                                key: template,
                                attrs: { label: template, value: template }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Results"),
                            prop: "col",
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("Results") },
                            model: {
                              value: _vm.spiderForm.col,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm, "col", $$v)
                              },
                              expression: "spiderForm.col"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { id: "add", size: "small", type: "primary" },
                          on: { click: _vm.onAddConfigurable }
                        },
                        [_vm._v(_vm._s(_vm.$t("Add")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isRunningTasksDialogVisible,
            title:
              _vm.$t("Latest Tasks") +
              " (" +
              _vm.$t("Spider") +
              ": " +
              (_vm.activeSpider ? _vm.activeSpider.name : "") +
              ")",
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isRunningTasksDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeSpiderTaskStatus,
                callback: function($$v) {
                  _vm.activeSpiderTaskStatus = $$v
                },
                expression: "activeSpiderTaskStatus"
              }
            },
            [
              _c("el-tab-pane", {
                attrs: { name: "pending", label: _vm.$t("Pending") }
              }),
              _c("el-tab-pane", {
                attrs: { name: "running", label: _vm.$t("Running") }
              }),
              _c("el-tab-pane", {
                attrs: { name: "finished", label: _vm.$t("Finished") }
              }),
              _c("el-tab-pane", {
                attrs: { name: "error", label: _vm.$t("Error") }
              }),
              _c("el-tab-pane", {
                attrs: { name: "cancelled", label: _vm.$t("Cancelled") }
              }),
              _c("el-tab-pane", {
                attrs: { name: "abnormal", label: _vm.$t("Abnormal") }
              })
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.activeNodeList,
                "header-cell-style": {
                  background: "rgb(48, 65, 86)",
                  color: "white"
                },
                border: "",
                "default-expand-all": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("h4", { staticStyle: { margin: "5px 10px" } }, [
                          _vm._v(_vm._s(_vm.$t("Tasks")))
                        ]),
                        _c(
                          "el-table",
                          {
                            staticClass: "table",
                            staticStyle: { margin: "5px 10px" },
                            attrs: {
                              data: _vm.getTasksByNode(scope.row),
                              border: "",
                              "max-height": "240px"
                            },
                            on: { "row-click": _vm.onViewTask }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Create Time"),
                                prop: "create_ts",
                                width: "140px"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Start Time"),
                                prop: "start_ts",
                                width: "140px"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Finish Time"),
                                prop: "finish_ts",
                                width: "140px"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Parameters"),
                                prop: "param",
                                width: "120px"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Status"),
                                width: "120px"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("status-tag", {
                                          attrs: { status: scope.row.status }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Results Count"),
                                prop: "result_count",
                                width: "80px"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: { label: _vm.$t("Action"), width: "auto" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        ["pending", "running"].includes(
                                          scope.row.status
                                        )
                                          ? _c("el-button", {
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                icon: "el-icon-video-pause"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onStop(
                                                    scope.row,
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Node"), width: "150px", prop: "name" }
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Status"),
                  width: "120px",
                  prop: "status"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === "offline"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v(_vm._s(_vm.$t("Offline")))
                            ])
                          : scope.row.status === "online"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(_vm._s(_vm.$t("Online")))
                            ])
                          : _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v(_vm._s(_vm.$t("Unavailable")))
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Description"),
                  width: "auto",
                  prop: "description"
                }
              })
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.isRunningTasksDialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Ok")))]
              )
            ],
            1
          )
        ],
        2
      ),
      _c("crawl-confirm-dialog", {
        attrs: {
          visible: _vm.crawlConfirmDialogVisible,
          "spider-id": _vm.activeSpiderId,
          spiders: _vm.selectedSpiders,
          multiple: _vm.isMultiple
        },
        on: {
          close: _vm.onCrawlConfirmDialogClose,
          confirm: _vm.onCrawlConfirm
        }
      }),
      _c("copy-spider-dialog", {
        attrs: {
          visible: _vm.copyDialogVisible,
          "spider-id": _vm.activeSpiderId
        },
        on: {
          close: function($event) {
            _vm.copyDialogVisible = false
          },
          confirm: _vm.onCopyConfirm
        }
      }),
      _c("batch-crawl-dialog", {
        attrs: { visible: _vm.batchCrawlDialogVisible },
        on: {
          close: _vm.onBatchCrawlDialogClose,
          confirm: _vm.onBatchCrawlConfirm
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Set Projects"),
            visible: _vm.setProjectsVisible,
            "before-close": function() {
              return (_vm.setProjectsVisible = false)
            },
            width: "580px"
          },
          on: {
            "update:visible": function($event) {
              _vm.setProjectsVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "set-projects-form",
              attrs: { "label-width": "120px", model: _vm.form }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Project"),
                    prop: "projectId",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small", placeholder: _vm.$t("Project") },
                      model: {
                        value: _vm.form.projectId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "projectId", $$v)
                        },
                        expression: "form.projectId"
                      }
                    },
                    _vm._l(_vm.projectList, function(op) {
                      return _c("el-option", {
                        key: op._id,
                        attrs: { label: op.name, value: op._id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "plain", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.setProjectsVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Stop")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onSetProjectsConfirm }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Confirm")) + " ")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-card",
        { staticStyle: { "border-radius": "0" } },
        [
          _c("div", { staticClass: "filter" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-form",
                  { attrs: { inline: true } },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: _vm.$t("Project")
                            },
                            on: { change: _vm.getList },
                            model: {
                              value: _vm.filter.project_id,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "project_id", $$v)
                              },
                              expression: "filter.project_id"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                value: "",
                                label: _vm.$t("All Projects")
                              }
                            }),
                            _vm._l(_vm.projectList, function(p) {
                              return _c("el-option", {
                                key: p._id,
                                attrs: { value: p._id, label: p.name }
                              })
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: _vm.$t("Owner Type")
                            },
                            on: { change: _vm.getList },
                            model: {
                              value: _vm.filter.owner_type,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "owner_type", $$v)
                              },
                              expression: "filter.owner_type"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                value: "me",
                                label: _vm.$t("My Spiders")
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "all",
                                label: _vm.$t("All Spiders")
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "public",
                                label: _vm.$t("Public Spiders")
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              size: "small",
                              placeholder: _vm.$t("Spider Name"),
                              clearable: ""
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onSearch($event)
                              }
                            },
                            model: {
                              value: _vm.filter.keyword,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "keyword", $$v)
                              },
                              expression: "filter.keyword"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-input__icon el-icon-search",
                              attrs: { slot: "suffix" },
                              slot: "suffix"
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn refresh",
                            attrs: { size: "small", type: "success" },
                            on: { click: _vm.onRefresh }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn add",
                    staticStyle: { "font-weight": "bolder" },
                    attrs: {
                      size: "small",
                      type: "danger",
                      icon: "el-icon-video-play"
                    },
                    on: { click: _vm.onBatchCrawl }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Batch Run")) + " ")]
                ),
                this.selectedSpiders.length
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn set-projects",
                        staticStyle: { "font-weight": "bolder" },
                        attrs: {
                          size: "small",
                          type: "primary",
                          icon: "el-icon-s-operation"
                        },
                        on: { click: _vm.onSetProjects }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Set Projects")) + " ")]
                    )
                  : _vm._e(),
                this.selectedSpiders.length
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn add",
                        staticStyle: { "font-weight": "bolder" },
                        attrs: {
                          size: "small",
                          type: "info",
                          icon: _vm.isStopLoading
                            ? "el-icon-loading"
                            : "el-icon-video-pause"
                        },
                        on: { click: _vm.onStopSelectedSpiders }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Stop")) + " ")]
                    )
                  : _vm._e(),
                this.selectedSpiders.length
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn add",
                        staticStyle: { "font-weight": "bolder" },
                        attrs: {
                          size: "small",
                          type: "danger",
                          icon: _vm.isRemoveLoading
                            ? "el-icon-loading"
                            : "el-icon-delete"
                        },
                        on: { click: _vm.onRemoveSelectedSpiders }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Remove")) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    staticClass: "btn add",
                    staticStyle: { "font-weight": "bolder" },
                    attrs: {
                      size: "small",
                      type: "success",
                      icon: "el-icon-plus"
                    },
                    on: { click: _vm.onAdd }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Add Spider")) + " ")]
                )
              ],
              1
            )
          ]),
          _c(
            "el-tabs",
            {
              staticClass: "tabs",
              on: { "tab-click": _vm.onClickTab },
              model: {
                value: _vm.filter.type,
                callback: function($$v) {
                  _vm.$set(_vm.filter, "type", $$v)
                },
                expression: "filter.type"
              }
            },
            [
              _c("el-tab-pane", {
                staticClass: "all",
                attrs: { label: _vm.$t("All"), name: "all" }
              }),
              _c("el-tab-pane", {
                staticClass: "customized",
                attrs: { label: _vm.$t("Customized"), name: "customized" }
              }),
              _c("el-tab-pane", {
                staticClass: "configurable",
                attrs: { label: _vm.$t("Configurable"), name: "configurable" }
              }),
              _c("el-tab-pane", {
                staticClass: "long-task",
                attrs: { label: _vm.$t("Long Task"), name: "long-task" }
              })
            ],
            1
          ),
          _c("status-legend"),
          _c(
            "el-table",
            {
              ref: "table",
              staticClass: "table",
              attrs: {
                data: _vm.spiderList,
                "header-cell-style": {
                  background: "rgb(48, 65, 86)",
                  color: "white"
                },
                border: "",
                "row-key": "_id"
              },
              on: {
                "row-click": _vm.onRowClick,
                "sort-change": _vm.onSortChange,
                "selection-change": _vm.onSpiderSelect
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "45",
                  align: "center",
                  "reserve-selection": ""
                }
              }),
              _vm._l(_vm.columns, function(col) {
                return [
                  col.name === "type"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          align: "left",
                          width: col.width,
                          sortable: col.sortable
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t(scope.row.type)) + " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "last_5_errors"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          width: col.width,
                          sortable: col.sortable,
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      style: {
                                        color:
                                          scope.row[col.name] > 0 ? "red" : ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scope.row[col.name]) + " "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "cmd"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          width: col.width,
                          sortable: col.sortable,
                          align: "left"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    model: {
                                      value: scope.row[col.name],
                                      callback: function($$v) {
                                        _vm.$set(scope.row, col.name, $$v)
                                      },
                                      expression: "scope.row[col.name]"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name.match(/_ts$/)
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getTime(scope.row[col.name])) +
                                      " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "last_status"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          align: "left",
                          width: col.width,
                          sortable: col.sortable
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("status-tag", {
                                    attrs: { status: scope.row.last_status }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : ["is_scrapy", "is_long_task"].includes(col.name)
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          align: "left",
                          width: col.width,
                          sortable: col.sortable
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.type === "customized"
                                    ? _c("el-switch", {
                                        attrs: {
                                          "active-color": "#13ce66",
                                          disabled: ""
                                        },
                                        model: {
                                          value: scope.row[col.name],
                                          callback: function($$v) {
                                            _vm.$set(scope.row, col.name, $$v)
                                          },
                                          expression: "scope.row[col.name]"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "latest_tasks"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          width: col.width,
                          align: col.align,
                          "class-name": "latest-tasks"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.getTaskCountByStatus(
                                    scope.row,
                                    "pending"
                                  ) > 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "small"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-loading"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getTaskCountByStatus(
                                                  scope.row,
                                                  "pending"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.getTaskCountByStatus(
                                    scope.row,
                                    "running"
                                  ) > 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "small"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-loading"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getTaskCountByStatus(
                                                  scope.row,
                                                  "running"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.getTaskCountByStatus(
                                    scope.row,
                                    "finished"
                                  ) > 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "small"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-check"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getTaskCountByStatus(
                                                  scope.row,
                                                  "finished"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.getTaskCountByStatus(scope.row, "error") >
                                  0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "small"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-error"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getTaskCountByStatus(
                                                  scope.row,
                                                  "error"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.getTaskCountByStatus(
                                    scope.row,
                                    "cancelled"
                                  ) > 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: { type: "info", size: "small" }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-video-pause"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getTaskCountByStatus(
                                                  scope.row,
                                                  "cancelled"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.getTaskCountByStatus(
                                    scope.row,
                                    "abnormal"
                                  ) > 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "small"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-warning"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getTaskCountByStatus(
                                                  scope.row,
                                                  "abnormal"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          property: col.name,
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align || "left",
                          width: col.width
                        }
                      })
                ]
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Action"),
                  align: "left",
                  fixed: "right",
                  "min-width": "280px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: { content: _vm.$t("View"), placement: "top" }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                                size: "mini",
                                disabled: _vm.isDisabled(scope.row)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onView(scope.row, $event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("Remove"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                size: "mini",
                                disabled: _vm.isDisabled(scope.row)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onRemove(scope.row, $event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: { content: _vm.$t("Copy"), placement: "top" }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "info",
                                icon: "el-icon-copy-document",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onCopy(scope.row, $event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        !_vm.isShowRun(scope.row)
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("No command line"),
                                  placement: "top"
                                }
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    disabled: "",
                                    type: "success",
                                    icon: "fa fa-bug",
                                    size: "mini"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onCrawl(scope.row, $event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("Run"),
                                  placement: "top"
                                }
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    type: "success",
                                    icon: "fa fa-bug",
                                    size: "mini",
                                    disabled: _vm.isDisabled(scope.row)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onCrawl(scope.row, $event)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("Latest Tasks"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "warning",
                                icon: "fa fa-tasks",
                                size: "mini",
                                disabled: _vm.isDisabled(scope.row)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onViewRunningTasks(
                                    scope.row,
                                    $event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("add pa"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "success",
                                icon: "el-icon-plus",
                                size: "mini",
                                disabled: _vm.isDisabled(scope.row)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onAddTasks(scope.row, $event)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pagination.pageNum,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pagination.pageSize,
                  layout: "sizes, prev, pager, next",
                  total: _vm.spiderTotal
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pagination, "pageNum", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pagination, "pageNum", $event)
                  },
                  "update:pageSize": function($event) {
                    return _vm.$set(_vm.pagination, "pageSize", $event)
                  },
                  "update:page-size": function($event) {
                    return _vm.$set(_vm.pagination, "pageSize", $event)
                  },
                  "current-change": _vm.onPageNumChange,
                  "size-change": _vm.onPageSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "cret",
          attrs: {
            visible: _vm.rejectDialog,
            "close-on-click-modal": false,
            width: "650px"
          },
          on: {
            "update:visible": function($event) {
              _vm.rejectDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "upload dialogComm" }, [
            _vm.isShow
              ? _c(
                  "div",
                  [
                    _c("h6", { staticClass: "saveEffects" }, [
                      _vm._v("新闻采集源配置")
                    ]),
                    _c(
                      "div",
                      { staticClass: "searchBox" },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "6",
                            placeholder: "请输入行政编码"
                          },
                          model: {
                            value: _vm.params.regionCode,
                            callback: function($$v) {
                              _vm.$set(_vm.params, "regionCode", $$v)
                            },
                            expression: "params.regionCode"
                          }
                        }),
                        _c("el-button", { on: { click: _vm.handleQuery } }, [
                          _vm._v("查询")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-bottom": "20px" },
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.handleAdd(true)
                          }
                        }
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.collectList, border: "" }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "Name", label: "名字" }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "Topic", label: "栏目/主题" }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "Url", label: "访问地址" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: scope.row.Url,
                                          placement: "top-start"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "100%",
                                              "white-space": "nowrap",
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis",
                                              cusor: "pointer"
                                            },
                                            attrs: { type: "text" }
                                          },
                                          [_vm._v(_vm._s(scope.row.Url))]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3613561564
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "RegionCode", label: "行政编码" }
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleAdd(
                                              false,
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#F56C6C" },
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteUrl(scope.row.Id)
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3330134004
                          )
                        })
                      ],
                      1
                    ),
                    _c("el-pagination", {
                      attrs: {
                        layout: "total, prev, pager, next",
                        total: _vm.collectTotal,
                        "current-page": _vm.params.pageNum,
                        "page-size": _vm.params.pageSize
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("h6", { staticClass: "saveEffects" }, [
                      _vm._v(_vm._s(_vm.isAdd ? "新增" : "编辑") + "新闻采集源")
                    ]),
                    _c(
                      "el-form",
                      {
                        ref: "model",
                        staticStyle: { display: "flex" },
                        attrs: { model: _vm.model, rules: _vm.modelRules }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "名字：",
                              "label-width": "100px",
                              prop: "Name"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "20",
                                placeholder: "请输入名字"
                              },
                              model: {
                                value: _vm.model.Name,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "Name", $$v)
                                },
                                expression: "model.Name"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "栏目/主题：",
                              "label-width": "100px",
                              prop: "Topic"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "40",
                                placeholder: "请输入栏目/主题"
                              },
                              model: {
                                value: _vm.model.Topic,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "Topic", $$v)
                                },
                                expression: "model.Topic"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "访问地址：",
                              "label-width": "100px",
                              prop: "Url"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                placeholder: "请输入访问地址"
                              },
                              model: {
                                value: _vm.model.Url,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "Url", $$v)
                                },
                                expression: "model.Url"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "行政编码：",
                              "label-width": "100px",
                              prop: "RegionCode"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "6",
                                placeholder: "请输入行政编码"
                              },
                              model: {
                                value: _vm.model.RegionCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "RegionCode", $$v)
                                },
                                expression: "model.RegionCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "标题：",
                              "label-width": "100px",
                              prop: "Title"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "50",
                                placeholder: "请输入标题XPath路径"
                              },
                              model: {
                                value: _vm.model.Title,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "Title", $$v)
                                },
                                expression: "model.Title"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "作者：",
                              "label-width": "100px",
                              prop: "Author"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "50",
                                placeholder: "请输入作者XPath路径"
                              },
                              model: {
                                value: _vm.model.Author,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "Author", $$v)
                                },
                                expression: "model.Author"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "日期：",
                              "label-width": "100px",
                              prop: "Date"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "50",
                                placeholder: "请输入日期XPath路径"
                              },
                              model: {
                                value: _vm.model.Date,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "Date", $$v)
                                },
                                expression: "model.Date"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "内容：",
                              "label-width": "100px",
                              prop: "Content"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "50",
                                placeholder: "请输入内容XPath路径"
                              },
                              model: {
                                value: _vm.model.Content,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "Content", $$v)
                                },
                                expression: "model.Content"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "新闻类型：",
                              "label-width": "100px",
                              prop: "Flag"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择新闻类型"
                                },
                                model: {
                                  value: _vm.model.Flag,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "Flag", $$v)
                                  },
                                  expression: "model.Flag"
                                }
                              },
                              _vm._l(_vm.optionsArr, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "50%" },
                            attrs: {
                              label: "摘要长度：",
                              "label-width": "100px",
                              prop: "Nlp"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入nlp生成摘要长度" },
                              model: {
                                value: _vm.model.Nlp,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "Nlp", _vm._n($$v))
                                },
                                expression: "model.Nlp"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btnBox",
                        staticStyle: {
                          "margin-top": "20px",
                          "text-align": "center"
                        }
                      },
                      [
                        _c("el-button", { on: { click: _vm.handleCancel } }, [
                          _vm._v("取消")
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleSave }
                          },
                          [_vm._v("保存")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }